// 缓存projectCode, projectName信息，后面再取的时候优先于localStorage和住这儿API

import { getProject } from './jsBridge';

// 解决住这儿API异步导致的如果项目是外盘的话接口会报错的问题
const cacheProjectInfo = {
  projectCode: '',
  projectName: '',
};

export const updateCacheProjectInfo = (
  projectCode?: string,
  projectName?: string,
) => {
  cacheProjectInfo.projectCode = projectCode || '';
  cacheProjectInfo.projectName = projectName || '';
};

export const getCacheProjectInfo = () => {
  return [cacheProjectInfo.projectCode, cacheProjectInfo.projectName];
};

export const initCacheProjectInfo = () => {
  getProject(res => {
    console.log('初始化 cacheProjectInfo', res.data);
    updateCacheProjectInfo(res.data?.projectCode, res.data?.projectName);
  });
};
